import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  useTheme,
  Checkbox,
} from '@mui/material';
import { PdfDocument } from '../../Document/PdfDocument';
import type { IDocument } from '../../Interfaces/IDocument';
import { useState } from 'react';
import { DocumentDialog } from './DocumentDialog';
import { useGetDocument } from '../../hooks/reactQuerys/DocumentQueries';

type IProps = {
  initialDocument: IDocument;
  selectable?: boolean;
  selected?: boolean;
  onSelectChange?: (selected: boolean) => void;
};

export const DocumentCard = ({
  initialDocument,
  selectable = false,
  selected = false,
  onSelectChange,
}: IProps) => {
  const theme = useTheme();

  const { document, isLoadingDocument } = useGetDocument({
    idDocument: initialDocument.idDocument,
    enabled: !initialDocument.Data,
  });

  const [showDocumentDialog, setShowDocumentDialog] = useState(false);

  const actualDocument = document ?? initialDocument;

  if (!isLoadingDocument && !actualDocument.Data) {
    return (
      <Card variant='outlined' sx={{ height: '100%' }}>
        <CardContent
          sx={{
            p: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Typography variant='body2' color='error'>
            Dokument konnte nicht geladen werden
          </Typography>
        </CardContent>
      </Card>
    );
  }

  const handleCardClick = () => {
    setShowDocumentDialog(true);
  };

  const handleCheckboxClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Verhindert, dass der Klick auch den Card-Click triggert
    e.stopPropagation();
    if (onSelectChange) {
      onSelectChange(!selected);
    }
  };

  return (
    <>
      <Box sx={{ position: 'relative' }} onClick={handleCardClick}>
        <Card
          variant='outlined'
          sx={{
            cursor: 'pointer',
            '&:hover': {
              border: `1px solid ${theme.palette.primary.main}`,
              transition: ' border 0.3s ease-in-out',
            },
          }}
        >
          <CardContent sx={{ p: 1 }}>
            <Typography variant='body2' noWrap title={actualDocument.FileName}>
              {actualDocument.FileName}
            </Typography>
            <Box
              sx={{
                height: '100px',
                overflow: 'hidden',
                mt: 1,
              }}
            >
              {actualDocument.Data ? (
                <PdfDocument
                  pdfFile={`data:application/pdf;base64,${actualDocument.Data}`}
                  numPages={1}
                  pageNumber={1}
                  scale={0.3}
                  setNumPages={() => {}}
                />
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                  }}
                >
                  <CircularProgress size={20} />
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
        {selectable && (
          <Checkbox
            checked={selected}
            onClick={handleCheckboxClick}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: 'rgba(255,255,255,0.8)',
            }}
          />
        )}
      </Box>
      <DocumentDialog
        document={actualDocument}
        open={showDocumentDialog}
        onClose={() => setShowDocumentDialog(false)}
      />
    </>
  );
};
